import { IXepTKBActionTypes } from "../../action-types/tkb/IXepTKBActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { eXepTKBStatus, IXepTKBReducer } from "../../reducer-model/tkb/IXepTKBReducer";
const iniState: IXepTKBReducer = {
    status: eReducerStatusBase.is_not_initialization,
    suKiens: [],
    filter: {
        hoc_ky: 0,
        id_chuyen_nganh: 0,
        id_he: 0,
        khoa_hoc: 0,
        ky_dang_ky: 0,
        nam_hoc: "",
        stu_nhomlop_ids: [],
        id_nganh: 0,
        pl_giaidoan_id: 0,
        id_bm: 0,
        id_mon: 0
    },
    keHoachMons: [],
    nhomLopGhepCapId: 0,
    nhomLopId: 0,
    monHocIdsChuaHoanThanh: [],
    monHocs: [],
    nhomLops: [],
    nhomLopCaHocGiaiDoans: [],
    modeDisplay: "chua-xep"
}
export const xepTKBReducer = (state: IXepTKBReducer = iniState, action: IXepTKBActionTypes): IXepTKBReducer => {
    switch (action.type) {
        case "XEP_TKB_LOAD_SU_KIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "XEP_TKB_LOAD_SU_KIEN_SUCCESS":
            return {
                ...state,
                suKiens: action.payload,
                status: eReducerStatusBase.is_completed
            }
        case "XEP_TKB_LOAD_SU_KIEN_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "XEP_TKB_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            }
        case "XEP_TKB_LOAD_ALL_START":
            return {
                ...state,
                status: eXepTKBStatus.is_loading_kh,
                keHoachMons: []
            }
        case "XEP_TKB_LOAD_ALL_SUCCESS":
            return {
                ...state,
                status: eXepTKBStatus.is_completed_kh,
                // keHoachMons: action.payload,
                monHocs: action.payload.monHocs,
                nhomLops: action.payload.nhomLops,
                suKiens: action.payload.suKiens,
                nhomLopCaHocGiaiDoans: action.payload.nhomLopCaHocGiaiDoans ?? []
            }
        case "XEP_TKB_LOAD_ALL_ERRR":
            return {
                ...state,
                status: eXepTKBStatus.is_completed_kh
            }
        case "XEP_TKB_UPDATE_SUKIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
                trungConflict: undefined
            }
        case "XEP_TKB_UPDATE_SUKIEN_TRUNG":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                trungConflict: action.payload
            }
        case "XEP_TKB_PATCH_SUKIENS":
            // Realtime từ người khác (hoặc chính mình) -> patch theo id; thêm mới nếu chưa có.
            const suKiensPatched = [...state.suKiens];
            action.payload.forEach(sk => {
                const idx = suKiensPatched.findIndex(x => x.id === sk.id);
                if (idx >= 0) {
                    suKiensPatched[idx] = {
                        ...suKiensPatched[idx],
                        ...sk,
                        // Dùng || (không phải ??): SP _Vm_By_Ids có thể trả ten_lop_hp = "" -> không được ghi đè tên cũ.
                        ten_lop_hp: sk.ten_lop_hp || suKiensPatched[idx].ten_lop_hp
                    }
                } else {
                    suKiensPatched.push(sk);
                }
            })
            return {
                ...state,
                suKiens: suKiensPatched
            }
        case "XEP_TKB_UPDATE_SUKIEN_SUCCESS":
            const suKiensNew = [...state.suKiens];
            action.payload.forEach(sk => {
                const idx = suKiensNew.findIndex(x => x.id === sk.id);
                if (idx >= 0) {
                    suKiensNew[idx] = {
                        ...suKiensNew[idx],
                        ...sk,
                        // Dùng || (không phải ??): tránh ten_lop_hp = "" từ server ghi đè tên cũ đã có.
                        ten_lop_hp: sk.ten_lop_hp || suKiensNew[idx].ten_lop_hp
                    }
                }
            })
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                suKiens: suKiensNew
            }
        case "XEP_TKB_UPDATE_SUKIEN_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "XEP_TKB_CHANGE_NHOMLOP_ID":
            return {
                ...state,
                nhomLopId: action.payload
            }
        case "XEP_TKB_CHANGE_NHOMLOP_GHEPCAP_ID":
            return {
                ...state,
                nhomLopGhepCapId: action.payload
            }
        case "XEP_TKB_CHANGE_KEHOACHMON_SELECTED":
            return {
                ...state,
                keHoachMonSelected: action.payload
            }
        case "XEP_TKB_LOAD_MON_HOC_START":
            return {
                ...state
            }
        case "XEP_TKB_LOAD_MON_HOC_SUCCESS":
            return {
                ...state,
                monHocs: action.payload
            }
        case "XEP_TKB_LOAD_MON_HOC_ERRR":
            return {
                ...state
            }
        case "XEP_TKB_LOAD_MON_HOC_CHUA_HT_START":
            return {
                ...state
            }
        case "XEP_TKB_LOAD_MON_HOC_CHUA_HT_SUCCESS":
            return {
                ...state,
                monHocIdsChuaHoanThanh: action.payload
            }
        case "XEP_TKB_LOAD_MON_HOC_CHUA_HT_ERRR":
            return {
                ...state
            }
        case "XEP_TKB_LOAD_NHOM_LOP_START":
            return {
                ...state
            }
        case "XEP_TKB_LOAD_NHOM_LOP_SUCCESS":
            return {
                ...state,
                nhomLops: action.payload
            }
        case "XEP_TKB_LOAD_NHOM_LOP_ERRR":
            return {
                ...state
            }
        case "XEP_TKB_UPDATE_GV_PH_SUKIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "XEP_TKB_UPDATE_GV_PH_SUKIEN_SUCCESS":
            const suKiensNewGVPH = [...state.suKiens];
            action.payload.forEach(sk => {
                const idx = suKiensNewGVPH.findIndex(x => x.id === sk.id);
                if (idx >= 0) {
                    suKiensNewGVPH[idx] = {
                        ...suKiensNewGVPH[idx],
                        ...sk
                    }
                }
            })
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                suKiens: suKiensNewGVPH
            }
        case "XEP_TKB_UPDATE_GV_PH_SUKIEN_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "XEP_TKB_UPDATE_NHOMLOP_SUKIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "XEP_TKB_UPDATE_NHOMLOP_SUKIEN_SUCCESS":
            const id_lop_tc = action.payload.lopTinChi.id_lop_tc;
            const newSuKiens = [...state.suKiens.filter(x => x.id_lop_tc !== id_lop_tc), ...action.payload.suKiens];
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                suKiens: newSuKiens,
            }
        case "XEP_TKB_UPDATE_NHOMLOP_SUKIEN_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "XEP_TKB_UPDATE_NHOMLOP_INFO":
            return {
                ...state,
                nhomLops: [...state.nhomLops.map(x => {
                    if (x.id === action.payload.id) {
                        return { ...x, ...action.payload }
                    }
                    return { ...x };
                })]
            }
        case "XEP_TKB_UPDATE_PHONG_HOC_SUKIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "XEP_TKB_UPDATE_PHONG_HOC_SUKIEN_SUCCESS":
            const suKiensNewPH = [...state.suKiens];
            action.payload.forEach(sk => {
                const idx = suKiensNewPH.findIndex(x => x.id === sk.id);
                if (idx >= 0) {
                    suKiensNewPH[idx] = {
                        ...suKiensNewPH[idx],
                        ...sk
                    }
                }
            })
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                suKiens: suKiensNewPH
            }
        case "XEP_TKB_UPDATE_PHONG_HOC_SUKIEN_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "XEP_TKB_CHANGE_MODE_DISPLAY":
            return {
                ...state,
                modeDisplay: action.payload
            }
        default:
            return {
                ...state
            };
    }
}